"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwliWidget = void 0;
var csod = require("player-core");
var React = require("react");
require("./AwliWidget.css");
var AwliWidget = (function (_super) {
    __extends(AwliWidget, _super);
    function AwliWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AwliWidget.prototype.shouldComponentUpdate = function () {
        return false;
    };
    AwliWidget.prototype.componentDidMount = function () {
        if (this.props.enabled) {
            var liScript = document.createElement('script');
            liScript.type = "text/javascript";
            liScript.src = "https://www.linkedin.com/mjobs/awli/awliWidget";
            document.body.appendChild(liScript);
        }
    };
    AwliWidget.prototype.render = function () {
        if (!this.props.enabled) {
            return null;
        }
        if (this.props.buttonMode === "BUTTON_DATA") {
            return React.createElement("div", { className: "p-awliwidget" },
                React.createElement("div", { className: "widget-holder", "data-tag": "LinkedInApplyButton" },
                    React.createElement("script", { type: "IN/AwliWidget", "data-company-job-code": csod.viewModel.jobDetail.ref, "data-integration-context": this.props.integrationContext, "data-mode": "BUTTON_DATA", "data-callback-method": "csodAwliCallback", "data-api-key": this.props.apiKey, "data-allow-sign-in": "true" })));
        }
        else if (this.props.buttonMode === "CONVERSION") {
            return React.createElement("div", { className: "p-awliwidget" },
                React.createElement("div", { className: "widget-holder", "data-tag": "LinkedInApplyButton" },
                    React.createElement("script", { type: "IN/AwliWidget", "data-company-job-code": csod.viewModel.jobDetail.ref, "data-integration-context": this.props.integrationContext, "data-mode": "CONVERSION", "data-api-key": this.props.apiKey })));
        }
        else {
            return null;
        }
    };
    AwliWidget.defaultProps = {
        enabled: false,
        integrationContext: '',
        apiKey: '',
        buttonMode: 'BUTTON_DATA'
    };
    return AwliWidget;
}(React.Component));
exports.AwliWidget = AwliWidget;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["AwliWidget"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/AwliWidget/AwliWidget.js
// module id = 201
// module chunks = 0 2